import { render, staticRenderFns } from "./ProductoExport.vue?vue&type=template&id=290fb949"
import script from "./ProductoExport.vue?vue&type=script&lang=js"
export * from "./ProductoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports